import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    button: 'Create a wallet',
    description: {
      plural:
        'Create up to {nbWallets} wallets now and enjoy an even more comprehensive experience.',
      singular:
        'Create a wallet now and enjoy an even more comprehensive experience.',
    },
    title: 'Welcome to Shine {planName}!',
  },
  fr: {
    button: 'Créer un sous‑compte',
    description: {
      plural:
        'Créez jusqu’à {nbWallets} sous‑comptes dès maintenant et profitez d’une offre encore plus complète.',
      singular:
        'Créez un sous‑compte dès maintenant et profitez d’une offre encore plus complète.',
    },
    title: 'Bienvenue sur Shine {planName}\u00A0!',
  },
});

export default locales;
